import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';

export interface IVHSSpacerProps extends IBaseElementProps {
	/**
	 * Size
	 */
	size: 'default' | 'small' | 'medium' | 'large';
}

/**
 * Spacer
 * @block
 * @icon move
 */
const VHSSpacer: React.FC<IVHSSpacerProps> = ({
	size,
}) => (
	<div
		className={cn(
			'vhs-spacer',
			(size === 'small') && 'vhs-spacer--small',
			(size === 'medium') && 'vhs-spacer--medium',
			(size === 'large') && 'vhs-spacer--large',
		)}
	>
	</div>
);

export default VHSSpacer;
